import { Component, OnInit } from '@angular/core';
import { AppUtils } from 'src/app/helpers/app.utils';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageUrls } from 'src/app/helpers/page-urls';
import { TableModel } from 'src/app/models/table.model';
import { Subscription } from 'rxjs';
import { ZohoBookService } from 'src/app/admin/services/zoho.book.service';
import { PagedZohoBookBillDetail } from 'src/app/admin/models/paged.zoho.book.bill.detail';

@Component({
    selector: 'app-zoho-book-bill-list',
    templateUrl: './zoho.book.bill.list.component.html',
    styleUrls: ['./zoho.book.bill.list.component.scss']
})
export class ZohoBookBillListComponent implements OnInit {

    totalRecords = 0;
    pagedZohoBookBillDetails = new PagedZohoBookBillDetail();
    subscriptions = new Array<Subscription>();
    tableModel = new TableModel();
    isModelLoaded = false;

    get urls() {
        return PageUrls;
    }

    constructor(private spinner: NgxSpinnerService,
        private toastr: ToastrService,
        private zohoBookService: ZohoBookService) {
        this.tableModel.orderBy = 'BillNumber';
        this.tableModel.orderByDirection = 'asc';
    }

    ngOnInit() {
        this.initSubscribers();
        this.getZohoBookBills();
    }

    initSubscribers() {
        const subscription = this.tableModel.pageChanged.subscribe(() => this.getZohoBookBills());
        this.subscriptions.push(subscription);
    }

    getZohoBookBills() {
        this.spinner.show();
        this.zohoBookService.list(this.tableModel).subscribe(
            data => {
                Object.assign(this.pagedZohoBookBillDetails, data);
                this.totalRecords = data.totalCount;
                this.pagedZohoBookBillDetails.items.forEach(bill => {
                    bill.date = AppUtils.getFormattedDate(bill.date);
                });

                this.spinner.hide();
                this.isModelLoaded = true;
            },
            error => {
                this.spinner.hide();
                AppUtils.processErrorResponse(this.toastr, error);
            });
    }
}
